<template>
  <div class="general-reporting">
    <div class="workload-data">
      <div class="workload-list mt-4 mx-3 pt-4" >
        <material-card
          color="orange"
          title="Email Audit Report">
          
          <div
            class="workload-list">
            <v-layout>
                <v-flex md3>
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="from_date"
                        label="Start Date"
                        prepend-icon="event"
                        clearable
                        readonly
                        v-on="on"
                    />
                    </template>
                    <v-date-picker
                    v-model="from_date"
                    @input="fromDateModal = false"/>
                </v-menu>
                </v-flex>
                <v-flex md3>
                <v-menu
                    v-model="endDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="end_date"
                        label="End Date"
                        prepend-icon="event"
                        clearable
                        readonly
                        v-on="on"
                    />
                    </template>
                    <v-date-picker
                    v-model="end_date"
                    @input="endDateModal = false"
                    @change="onDateFilterUpdate"/>
                </v-menu>
                </v-flex>
            </v-layout>

            <v-progress-linear
                v-slot:progress
                v-if="loadingRequest"
                color="orange"
                indeterminate/>
            <v-data-table
              :headers="setTableHeader"
              :items="emailAuditList"
              :pagination.sync="pagination"
              item-key="id"
              disable-initial-sort
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.sent }}</td>
                  <td>{{ props.item.success }}</td>
                  <td>{{ props.item.module }}</td>
                  <td>{{ props.item.sender }}</td>
                  <td>{{ props.item.receiver }}</td>
                  <td>{{ props.item.ccopy }}</td>
                  <td>{{ props.item.subject }}</td>
                  <td>{{ props.item.msg }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </material-card>
      </div>
    </div>
  </div>
</template>
<script>

import { mapMutations, mapState } from 'vuex'

export default {
  $_veeValidate: { validator: 'new' },
  data () {
    return {
      from_date: '',
      end_date: '',
      fromDateModal: false,
      endDateModal: false,
      tableHeader : ['Id', 'Sent_Date', 'Success', 'Module', 'Sender', 'Recipient', 'Cc', 'Subject', 'Message_Body'],
      pagination: {
        descending: true,
        sortBy: 'Sent_Date',
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      }
    }
  },
  mounted () {
    this.$store.dispatch('admin/retrieveEmailTrail', {action: "email-trail"})
  },
  computed: {
    ...mapState('admin', ['emailAuditHeaders', 'emailAuditList', 'loadingRequest']),
    setTableHeader () {
      return this.emailAuditHeaders.filter(header => this.tableHeader.includes(header.value))
    }
   
  },
  methods: {
    onDateFilterUpdate (){
        this.$store.dispatch('admin/retrieveEmailTrail', {
            action: "email-trail", from_date: this.from_date, end_date: this.end_date
            }
        )
    }
  }
}
</script>

<style lang="scss" scoped>
.general-reporting {

  .workload-detail-view {
    width: 80%;
    margin: 0 auto;

    table {
      width: 100%;
    }

    td, th {
      border: 1px solid #ddd;
      padding: 8px;
    }

    tr:nth-child(even){background-color: #f2f2f2;}

    tr:hover {background-color: #ddd;}

    th {
      padding-top: 12px;
      padding-bottom: 12px;
      text-align: left;
      background-color: #ffa726;
      color: #fff;
    }

  }
}
</style>
